export default __webpack_public_path__ + "static/media/research1.c2db83bb.jpg";